import { Loader } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import useSWR from 'swr'

import ScrollableScreen from '@/components/ui/ScrollableScreen'
import ProfileSettings from '@/components/profiles/ProfileSettings'
import { useAxiosApi } from '@/hooks/useAxiosApi'

export default function MePage() {
    const { t } = useTranslation()
    const { requestGet } = useAxiosApi()

    const { data, isLoading, mutate } = useSWR('/me', requestGet)
    const profile = data?.data?.profile

    const breadcrumbs = [{ label: t('settings') }]

    if (isLoading || !profile) {
        return (
            <ScrollableScreen breadcrumbs={breadcrumbs}>
                <div className="flex items-center justify-center p-12">
                    <Loader />
                </div>
            </ScrollableScreen>
        )
    }

    return (
        <ScrollableScreen breadcrumbs={breadcrumbs}>
            <ProfileSettings
                profile={profile}
                isOwnProfile
                onMutate={mutate}
            />
        </ScrollableScreen>
    )
}
